import { Directive, ElementRef, EventEmitter, forwardRef, HostListener, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_LEGACY_INPUT_VALUE_ACCESSOR as MAT_INPUT_VALUE_ACCESSOR } from '@angular/material/legacy-input';

@Directive({
  selector: 'input[localizedNumericInput]',
  providers: [
    { provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: LocalizedNumericInputDirective },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocalizedNumericInputDirective),
      multi: true,
    },
  ],
})
export class LocalizedNumericInputDirective implements ControlValueAccessor {
  private _value: number | null = null;
  private numberFormat = new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  });

  constructor(private element: ElementRef<HTMLInputElement>) {}

  get value(): number | null {
    return this._value;
  }

  @Input('value')
  set value(value: number | null) {
    this._value = value;
    this.formatValue(value);
  }

  @Input('localizedNumericInput') set valor(valor: number) {
    this.formatValue(valor);
  }

  @Output('localizedNumericInputChange') valorChange = new EventEmitter<number>();

  @HostListener('input', ['$event.target.value'])
  input(value: string) {
    const numericValue = parseFloat(value.replace(/\s/g, '').replace(/,/g, '.'));
    if (!isNaN(numericValue)) {
      this._value = numericValue;
      this._onChange(this._value);
    } else {
      this._value = null;
      this._onChange(null);
    }
  }

  @HostListener('blur')
  onBlur() {
    this.formatValue(this._value);
    if (this._value !== null) {
      this.valorChange.emit(this._value);
    }
  }

  @HostListener('focus')
  onFocus() {
    this.unFormatValue();
  }

  _onChange(value: any): void {}

  writeValue(value: any) {
    this._value = value;
    this.formatValue(this._value);
  }

  registerOnChange(fn: (value: any) => void) {
    this._onChange = fn;
  }

  registerOnTouched() {}

  private formatValue(value: number | null) {
    if (value === null) {
      this.element.nativeElement.value = '';
    } else {
      this.element.nativeElement.value = this.numberFormat.format(value);
    }
  }

  private unFormatValue() {
    if (this._value !== null) {
      this.element.nativeElement.value = this._value.toString().replace('.', ',');
    }
  }
}
